import { useState } from 'react';
import { AnalysisContainer, ConcernBox, ConcernBoxContainer, ConcernBoxTextAndScoreContainer, HydrationBox, HydrationContainer, HydrationContainerTab, ImageAndAnalysisContainer, ResultH3, ScoreBoxEmpty, Scorebox, SubComponent, UVPictureSkeleton } from '../../styles/newResultsStyle';
import { useSelector } from 'react-redux';
import { CliniqueState, ResultStep } from '../../type';
import { translateAnalyseName } from '../../constantes/utilitaries';
import { useTranslation } from 'react-i18next';
import { AnimatePresence } from 'framer-motion';
import { DetailedConcernPageTab } from './detailedSkinTab';
import ConcernImage from '../ConcernImage';
import { AnalysisConcernCanvas } from '../../styles/concernImageStyle';

interface ScoreI {
	openPopUp: Function;
	resultStep: ResultStep;
	setForcedConcern: Function;
}

export const ScoreTab = (props: ScoreI) => {
	const { analyses: analysis, market } = useSelector((state: CliniqueState) => state.session);
	const [selectedAnalysis, selectAnalysis] = useState<string | null>(analysis[0]?.name);
	const [isConcernListDisplayed, displayConcernList] = useState<boolean>(false);
	const isActive = props.resultStep === ResultStep.score;

	const { t } = useTranslation();
	const selectedConcern = analysis.find((analyse) => analyse.name === selectedAnalysis);

	const selectConcern = (concernName: string) => {
		selectAnalysis(concernName);
	};

	return (
		<SubComponent
			id='PAGE_CONTAINER'
			style={{
				backgroundColor: '#FAFAFA',
				justifyContent: 'initial',
				padding: '0px',
				height: isActive ? 'auto' : '0px',
				maxHeight: isActive ? 'none' : '0px',
				overflow: isActive ? 'visible' : 'hidden',
			}}
			$height={isActive ? 'initial' : '0px'}>
			<AnimatePresence>
				<ConcernBoxContainer key={'CONTAINER'} layout $isAbsolute={isConcernListDisplayed}>
					<ImageAndAnalysisContainer>
						<div style={{ position: 'relative', flex: 1, overflow: 'hidden', maxHeight: '500px' }}>
							{selectedConcern ? <ConcernImage as={AnalysisConcernCanvas} concern={selectedConcern.name} image={selectedConcern.imageURL ?? ''} /> : <UVPictureSkeleton />}
						</div>

						<AnalysisContainer>
							{analysis.find((analyse) => analyse.name === 'dehydration')!.score > -1 && <HydrationContainerTab>
								<HydrationContainer layout id='HYDRATION_CONTAINER' key='HYDRATION_CONTAINER' initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
									<HydrationBox $selected={true}>Hydrated</HydrationBox>

									<HydrationBox $isRight $selected={false}>
										Dehydrated
									</HydrationBox>
								</HydrationContainer>
							</HydrationContainerTab>}

							{analysis
								.filter((analyse) => analyse.name !== 'dehydration')
								.sort((a, b) => {
									return b.score - a.score;
								})
								.map((analyse) => (
									analyse.score > -1 && <ConcernBox
										layout
										key={'BOX_' + analyse.name}
										initial={{ opacity: 0 }}
										animate={{ opacity: 1 }}
										exit={{ opacity: 0 }}
										onClick={() => {
											selectConcern(analyse.name);
											if (isConcernListDisplayed) {
												displayConcernList(false);
											}
										}}
										id={'BOX_' + analyse.name}
										$selected={selectedAnalysis === analyse.name}>
										<AnimatePresence>
											<ConcernBoxTextAndScoreContainer>
												<ResultH3 style={{ textAlign: 'start', color: selectedAnalysis === analyse.name ? 'white' : 'initial' }}>{translateAnalyseName(t, analyse.name, market)}</ResultH3>

												<ScoreBoxEmpty>
													<Scorebox $isDisplayed={analyse.score >= 0.05} />
													<Scorebox $isDisplayed={analyse.score > 0.2} />
													<Scorebox $isDisplayed={analyse.score > 0.4} />
													<Scorebox $isDisplayed={analyse.score > 0.6} />
													<Scorebox $isDisplayed={analyse.score > 0.8} />
												</ScoreBoxEmpty>
											</ConcernBoxTextAndScoreContainer>
										</AnimatePresence>
									</ConcernBox>
								))}
						</AnalysisContainer>
					</ImageAndAnalysisContainer>
				</ConcernBoxContainer>
			</AnimatePresence>

			<AnimatePresence initial={false}>{<DetailedConcernPageTab setForcedConcern={props.setForcedConcern} displayPopUp={props.openPopUp} concernName={selectedAnalysis} />}</AnimatePresence>
		</SubComponent>
	);
};
